class ProductCardSwatches extends HTMLElement {
  constructor() {
    super();
    this.swatches = [];
    this.productCard = null;
  }

  connectedCallback() {
    this.init();
    this.setupEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  init() {
    this.productCard = this.closest('.product-card');
    if (!this.productCard) {
      console.warn('ProductCardSwatches: No product card found');
      return;
    }

    this.swatches = Array.from(this.querySelectorAll('.swatch-links__item'));
    
    if (this.swatches.length === 0) {
      console.warn('ProductCardSwatches: No swatch elements found');
      return;
    }
  }

  setupEventListeners() {
    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', this.handleSwatchClick.bind(this));
    });
  }

  removeEventListeners() {
    this.swatches.forEach(swatch => {
      swatch.removeEventListener('click', this.handleSwatchClick.bind(this));
    });
  }

  handleSwatchClick(event) {
    const swatch = event.currentTarget;
    event.preventDefault();
    this.updateProductCard(swatch);
  }

  updateProductCard(swatch) {
    try {
      const mainImage = swatch.dataset.mainImage;
      const secondaryImage = swatch.dataset.secondaryImage;
      const title = swatch.dataset.title;
      const price = swatch.dataset.price;
      const productUrl = swatch.dataset.productUrl;

      this.updateImage('.product-card__image--primary', mainImage);
      this.updateImage('.product-card__image--secondary', secondaryImage);
      this.updateTitle(title);
      this.updatePrice(price);
      this.updateLinks(productUrl);
      this.updateActiveSwatch(swatch);
      this.dispatchProductCardUpdate(swatch);

    } catch (error) {
      console.error('ProductCardSwatches: Error updating product card', error);
    }
  }

  updateImage(selector, imageUrl) {
    const imageElement = this.productCard.querySelector(selector);
    if (imageElement && imageUrl) {
      imageElement.src = imageUrl;
      if (imageElement.hasAttribute('srcset')) {
        imageElement.removeAttribute('srcset');
      }
    }
  }

  updateTitle(title) {
    const titleElement = this.productCard.querySelector('.product-card__title');
    if (titleElement && title) {
      titleElement.textContent = title;
    }
  }

  updatePrice(price) {
    const priceElement = this.productCard.querySelector('.product-card__price');
    if (priceElement && price) {
      priceElement.innerHTML = price;
    }
  }

  updateLinks(productUrl) {
    const links = this.productCard.querySelectorAll('a');
    links.forEach(link => {
      if (productUrl) {
        link.href = productUrl;
      }
    });
  }

  updateActiveSwatch(activeSwatch) {
    const currentActive = this.productCard.querySelector('.swatch-links__item.active');
    if (currentActive) {
      currentActive.classList.remove('active');
    }
    activeSwatch.classList.add('active');
  }

  dispatchProductCardUpdate(swatch) {
    const event = new CustomEvent('productCardUpdated', {
      detail: {
        swatch: swatch,
        productCard: this.productCard,
        data: {
          mainImage: swatch.dataset.mainImage,
          secondaryImage: swatch.dataset.secondaryImage,
          title: swatch.dataset.title,
          price: swatch.dataset.price,
          productUrl: swatch.dataset.productUrl
        }
      },
      bubbles: true
    });
    
    this.productCard.dispatchEvent(event);
  }

  updateFromSwatch(swatch) {
    this.updateProductCard(swatch);
  }
}

customElements.define('td-product-card-swatches', ProductCardSwatches);

if (typeof module !== 'undefined' && module.exports) {
  module.exports = ProductCardSwatches;
}
